import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from '@mui/material';
import { AuditEvent } from '../../services/platformApi';
import { useLanguage } from '../../LanguageContext';

interface AuditTabProps {
  auditEvents: AuditEvent[];
}

export const AuditTab: React.FC<AuditTabProps> = ({ auditEvents }) => {
  const { locale, t } = useLanguage();

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('time')}</TableCell>
            <TableCell>{t('action')}</TableCell>
            <TableCell>{t('target')}</TableCell>
            <TableCell>{t('actor')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {auditEvents.map((event) => (
            <TableRow key={event.id} hover>
              <TableCell>
                {event.created_at ? new Date(event.created_at).toLocaleString(locale) : t('notRecorded')}
              </TableCell>
              <TableCell>{event.action}</TableCell>
              <TableCell>
                {event.target_type}
                {event.target_id ? ` #${event.target_id}` : ''}
              </TableCell>
              <TableCell>{event.actor_user_id ? `${t('user')} #${event.actor_user_id}` : event.actor_type}</TableCell>
            </TableRow>
          ))}
          {auditEvents.length === 0 && (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography color="text.secondary" align="center" sx={{ py: 5 }}>
                  {t('noProjectAuditEvents')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
